/* eslint-disable @typescript-eslint/no-unused-vars */
import { MenuState } from '@features/main/interfaces/main.interfaces';
import { DivisionCliente } from '@interfaces/firestore-documents.interfaces';
import { Chip, Typography } from '@mui/material';
import { DropDown, DropDownItem, InformationContainer, ListItem } from '@features/common';
import { ProcessesTable } from '@features/processes';
import useDivisionStyles from './Division.styles';
import { handleClick } from './Division.handlers';
import useFirebase from '@hooks/firebase.hook';

interface Props {
	data: DivisionCliente;
	menuState: MenuState;
	searchedProcess: string;
	setDivisionNumber: React.Dispatch<React.SetStateAction<string>>;
	tabIndex: number;
}

const Division: React.FC<Props> = ({
	data,
	menuState,
	searchedProcess,
	setDivisionNumber,
	tabIndex,
}) => {
	const { serviceLevels } = useFirebase();
	const classes = useDivisionStyles();

	return (
		<div className={classes.root}>
			{!data.activo && (
				<Chip
					className={classes.stateChip}
					color="error"
					label="La división está inactiva"
					size="small"
				/>
			)}
			<InformationContainer
				canClick={data.activo}
				disabled={!data.activo}
				id={`division-${data.codigo_div}`}
				onClick={handleClick(data.codigo_div, setDivisionNumber)}
				style={{
					height: '100%',
					paddingBottom: 29,
					paddingLeft: 19,
					paddingRight: 24,
					paddingTop: 24,
					borderRadius: 20,
				}}
				tabIndex={tabIndex}
			>
				<Typography
					color="#003C82"
					fontFamily="Montserrat"
					fontSize={18}
					fontWeight={800}
					id={`division-${data.codigo_div}-name`}
				>
					{data.codigo_div} <span style={{ fontWeight: 700 }}>{data.nombre_div}</span>
				</Typography>
				<div className={classes.informationContainer}>
					<ListItem
						id={`division-${data.codigo_div}-information-business-advisor`}
						title="Asesor comercial"
						value={data.nombre_asesor_comercial || 'Sin registrar'}
						valueStyle={{ fontSize: 14 }}
					/>
					<ListItem
						id={`division-${data.codigo_div}-information-account-terminal`}
						title="Terminal de cuenta"
						value={data.terminal_de_cuenta || 'Sin registrar'}
						valueStyle={{ fontSize: 14 }}
					/>
					<ListItem
						id={`division-${data.codigo_div}-information-payment-terminal`}
						title="Terminal de cobro"
						value={data.terminal_de_cobro || 'Sin registrar'}
						valueStyle={{ fontSize: 14 }}
					/>
					<ListItem
						id={`division-${data.codigo_div}-information-account-type`}
						title="Tipo de cuenta"
						value={data.tipo_de_cuenta || 'Sin registrar'}
						valueStyle={{ fontSize: 14 }}
					/>
					<ListItem
						id={`division-${data.codigo_div}-information-service-levels`}
						title="Servicios"
						value={
							data.niveles_servicio.length > 0 ? (
								<DropDown
									id={`division-${data.codigo_div}-information-service-levels-dropdown`}
									title={`${data.niveles_servicio.length} servicios`}
								>
									{data.niveles_servicio
										.sort((a, b) => a - b)
										.map((ns, i) => (
											<DropDownItem
												code={ns.toString()}
												id={`division-${data.codigo_div}-information-service-levels-dropdown-${ns}`}
												key={`division-${data.codigo_div}-information-service-levels-dropdown-${ns}-${i}`}
												title={serviceLevels[ns] ?? 'Sin registrar'}
											/>
										))}
								</DropDown>
							) : (
								'0 servicios'
							)
						}
						valueStyle={{ fontSize: 14 }}
					/>
					<ListItem
						id={`division-${data.codigo_div}-information-combos`}
						title="Combos de servicios"
						value={
							data.combos.length > 0 ? (
								<DropDown
									id={`division-${data.codigo_div}-information-combos-dropdown`}
									title={`${data.combos.filter((i) => i.estado).length} combos`}
								>
									{data.combos
										.filter((c) => c.id_combo != undefined)
										.sort((a, b) => a.id_combo - b.id_combo)
										.map((c, i) => {
											if (c.estado) {
												return (
													<DropDownItem
														code={c.id_combo.toString()}
														id={`division-${data.codigo_div}-information-combos-dropdown-${c.id_combo}`}
														key={`division-${data.codigo_div}-information-combos-dropdown-${c.id_combo}-${i}`}
														title={c.nombre_combo}
													/>
												);
											}
										})}
								</DropDown>
							) : (
								'0 combos'
							)
						}
						valueStyle={{ fontSize: 14 }}
					/>
				</div>
				<Typography
					color="#003C82"
					fontFamily="Montserrat"
					fontSize={18}
					fontWeight={700}
					id={`division-${data.codigo_div}-information-processes-title`}
					style={{ marginTop: 24 }}
				>
					Procesos
				</Typography>
				<ProcessesTable
					data={data.procesos}
					id={`division-${data.codigo_div}-information-processes`}
					menuState={menuState}
					searchedProcess={searchedProcess}
				/>
			</InformationContainer>
		</div>
	);
};

export default Division;
